module.exports = __webpack_public_path__ + "img/f1.a99ce7f5.png";